import { getCSRCookieData } from '@/app/api/CSR/getCSRCookieData'
import isSSR from './isSSR'

const uuid = () => {
  if (isSSR()) return ''
  const uuid = getCSRCookieData('_IL-unique-id') ?? ''
  return uuid
}

export default uuid
